<template>
  <div style="display: flex; height: 100%">
    <div :class="classObj" class="app-wrapper">
      <div
        v-if="device === 'mobile' && sidebar.opened"
        class="drawer-bg"
        @click="handleClickOutside"
      />
      <sidebar class="sidebar-container" />
      <div :class="{ hasTagsView: needTagsView }" class="main-container">
        <div :class="{ 'fixed-header': fixedHeader }">
          <navbar />
          <tags-view v-if="needTagsView" />
        </div>

        <div class="app-main-bookmark">
          <app-main id="app-main" class="app-main" />
          <div id="bookmark-container"></div>
        </div>

        <!-- <right-panel v-if="showSettings"> -->
        <!-- <settings /> -->
        <!-- </right-panel> -->
        <!-- <div class="auto">
        <iframe class="iframe-style"  marginwidth="0" framespacing="0" marginheight="0" frameborder="0"  allowtransparency="true" src="http://172.18.20.15:8002"></iframe>
      </div> -->
      </div>
      <!-- <bookmark
          class="bookmark"
          mountId="app-main"
          contentId="app-main-book-mark"
          :bookmarkData="bookmarkData"
        /> -->
      <bookmark
        class="bookmark"
        mountId="bookmark-container"
        contentId="bookmark-container-book-mark"
      />
    </div>
  </div>
</template>

<script>
// import RightPanel from "@/components/RightPanel";
import {
  AppMain,
  Navbar,
  Settings,
  Sidebar,
  TagsView,
  AI,
  Catalogue,
  Notepad,
} from "./components";

import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";
import $ from "jquery";
import "jquery.terminal";
import "jquery.terminal/css/jquery.terminal.min.css"; // 确保引入 CSS
import bookmark from "@/views/tool/bookmark/index.vue";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    // RightPanel,
    Settings,
    Sidebar,
    TagsView,
    bookmark,
  },
  data() {
    return {
      isExpanded: false, // 控制菜单展开和收起
      isOpenRight: false,
      iframeType: "a",
      GitIsTrue: false,
      bookmarkData: [
        { text: "AI knowledge", value: "ai", component: AI },
        { text: "Notepad", value: "notepad", component: Notepad },
        { text: "Catalogue", value: "catalogue", component: Catalogue },
      ],
    };
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
        isOpenRight: this.isOpenRight,
      };
    },
  },
  methods: {
    openT() {
      this.GitIsTrue = true;
      new Promise((resolve, reject) => {
        this.GitIsTrue = true;
        setTimeout(() => {
          resolve();
        }, 100);
      }).then((res) => {
        $("#terminal").terminal(
          function (command) {
            if (command !== "") {
              try {
                var result = window.eval(command);
                if (result !== undefined) {
                  this.echo(new String(result));
                }
              } catch (e) {
                this.error(new String(e));
              }
            } else {
              this.echo("");
            }
          },
          {
            greetings: "Git Terminal",
            name: "js_demo",
            height: 400,
            prompt: "git> ",
          }
        );
      });
    },
    open(a) {
      if (a == "c") {
        this.isOpenRight = false;
        if (this.sidebar.opened) {
          new Promise((resolve, reject) => {
            this.$store.dispatch("app/closeSideBar", {
              withoutAnimation: false,
            });
            resolve();
          }).then((res) => {
            this.$store.dispatch("app/toggleSideBar");
          });
        } else {
          new Promise((resolve, reject) => {
            this.$store.dispatch("app/toggleSideBar");
            resolve();
          }).then((res) => {
            this.$store.dispatch("app/closeSideBar", {
              withoutAnimation: false,
            });
          });
        }
        try {
          let d = document.getElementsByClassName("file-show-type");
          console.log(d);
          for (let i in d) {
            console.log(i);
            d[i].style.display = "none";
          }
        } catch (error) {}
        return;
      }

      this.iframeType = a;
      // alert()
      this.isOpenRight = true;
      if (a == "d") {
        try {
          let d = document.getElementsByClassName("file-show-type");
          console.log(d);
          d[1].style.display = "block";
        } catch (error) {}
      }
    },
    toggleMenu() {
      this.isExpanded = !this.isExpanded;
    },
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
  },
};
</script>

<style lang="scss" scoped>
#app-main {
  position: relative;
}
.main-container {
  display: flex;
  flex-direction: column;
  height: 100% !important;
  min-width: 600px;
}
.app-main-bookmark {
  flex-grow: 1;
  height: calc(100% - 85px);
  width: 100%;
  display: flex;
  .app-main {
    // flex-grow: 1;
    height: 100%;
    width: calc(100% - 25px);
  }
  #bookmark-container {
    background: #f5f5f5;
    width: 22px;
  }
}

.bookmark {
  z-index: 99999;
}
.dowm {
  position: fixed;
  right: 0;
  bottom: 200px;
  width: auto !important;
  // transform:
  z-index: 999;
}
.right-content {
  width: 0px;
  height: 100%;
  // background-color: red;
  padding: 4px;
  position: fixed;
  right: 0;
  z-index: 989;
  iframe {
    border: none;

    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); /* 示例阴影效果 */
    width: 100%;
    position: absolute;
    height: 100%;
  }
}
.auto {
  position: fixed;
  right: 10px;
  top: 10px;
  width: 500px;
  height: 800px;
  background-color: #fff;
  z-index: 9999;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); /* 示例阴影效果 */
  .iframe-style {
    border: none; /* 取消iframe自带的边框 */
    width: 100%;
    height: 100%;
  }
}
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.isOpenRight {
  width: calc(100% - 600px);
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>

<style>
.wl-explorer .wl-header-btn {
  box-shadow: none !important;
}
.wl-explorer {
  /* box-shadow: 6px 6px 15px rgba(0, 0, 0, 0.8); */
}

#app-main-book-mark {
  position: fixed !important;
  right: 0px;
  top: 80px;
  z-index: 9999;
}
</style>
